import { CREATIVE_TYPE, FORM_MODES } from 'modules/campaigns/config';
import { useWochit } from 'modules/campaigns/modules/creative-creator/services/wochit';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormDataContext, useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';

export const useMotionStudioStatus = () => {
    // default object used to prevent crashes if this hook is used somewhere wochit is not activated
    const { wochitSDK, wochitAccessToken } = useWochit() || {};
    const isWochitAccessTokenInvalid = wochitAccessToken == null || wochitAccessToken.length === 0 || !wochitSDK;
    const isCreateVideoViaWochitEnable = useConfigMatch({
        [FEATURE_FLAGS.WOCHIT_CREATE_VIDEO_ENABLED]: 'true',
    });
    const { mode } = useFormDataContext();
    const isDuplicateMode = mode === FORM_MODES.DUPLICATE;
    const { value: creativeType } = useFormFieldValue({ field: 'creativeType' });
    const isModeLockedForMotionAdsStudio =
        creativeType && creativeType !== CREATIVE_TYPE.MOTION && creativeType !== CREATIVE_TYPE.VIDEO;

    const isMotionStudioEnabled = isCreateVideoViaWochitEnable && (isDuplicateMode || !isModeLockedForMotionAdsStudio);

    return {
        isMotionStudioEnabled,
        isWochitAccessTokenInvalid,
    };
};
